import { Menu, type MenuSelectGroupProps, Text } from "@overmap-ai/blocks"
import type { IssueTypeStatus, Stored } from "@overmap-ai/common"
import { memo } from "react"

import { IssueTypeStatusIcon } from "../Icons/IssueTypeStatusIcon"
import { SelectItemTemplate } from "../MenuGroups/constants"

export type IssueTypeStatusSelectGroupProps = MenuSelectGroupProps<Stored<IssueTypeStatus>> & {
	issueTypeStatuses: Stored<IssueTypeStatus>[]
}

export const IssueTypeStatusSelectGroup = memo<IssueTypeStatusSelectGroupProps>((props) => {
	const { ref, issueTypeStatuses, ...rest } = props

	return (
		<Menu.SelectGroup<Stored<IssueTypeStatus>> ref={ref} {...rest}>
			{issueTypeStatuses.map((issueTypeStatus) => (
				<SelectItemTemplate<Stored<IssueTypeStatus>> key={issueTypeStatus.uuid} value={issueTypeStatus}>
					<IssueTypeStatusIcon issueTypeStatusId={issueTypeStatus.uuid} />
					<Text className="truncate">{issueTypeStatus.name}</Text>
				</SelectItemTemplate>
			))}
		</Menu.SelectGroup>
	)
})
IssueTypeStatusSelectGroup.displayName = "IssueTypeStatusSelectGroup"
